interface IClipboardData {
  interval?: number;
  onFinally: (status: boolean) => void;
  text: string;
}

interface IShareData {
  text: string;
  title: string;
  url: string;
}

export const canUseShare = typeof window !== 'undefined' && 'share' in navigator;
export const canUseClipboard = typeof window !== 'undefined' && 'clipboard' in navigator;

export const shareData = (data: IShareData) => {
  if ('share' in navigator) {
    navigator.share(data).catch((err) => console.error(err));
  }
};

export const clipboardData = ({ text, onFinally, interval = 2000 }: IClipboardData) => {
  if ('clipboard' in navigator) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        onFinally(true);
        const intervalAlert = setTimeout(() => {
          onFinally(false);
          clearInterval(intervalAlert);
        }, interval);
      })
      .catch((err) => console.error(err));
  }
};
